import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Checkbox } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import AdvancedCombobox from '../Helper/AdvancedCombobox';
import Combobox from '../Helper/Combobox';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Contact from './Contact';

/**
* Class Echange
* Echange view component
**/
class Echange extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Echange";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let dateHeureEchange = null, dateRelance = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateHeureEchange) {

        dateHeureEchange = this.state.object.dateHeureEchange;

        if(typeof dateHeureEchange === "string") {
          dateHeureEchange = getDateFromString(dateHeureEchange);
        }

        dateHeureEchange = getIsoStringFromDate(dateHeureEchange);
      }

      if(this.state.object.dateRelance) {

        dateRelance = this.state.object.dateRelance;

        if(typeof dateRelance === "string") {
          dateRelance = getDateFromString(dateRelance);
        }

        dateRelance = getIsoStringFromDate(dateRelance);
      }
    }

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="echangeForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'échange.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idEchange" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idEchange")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="dateHeureEchange">
            <Col componentClass={ControlLabel} sm={2}>Date de l'échange</Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" value={dateHeureEchange} onChange={this.handleDateHeureEchangeChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* TypeEchange ManyToOne */}
          <FormGroup controlId="idTypeEchange">
            <Col componentClass={ControlLabel} sm={2}>Type d'échange</Col>
            <Col sm={6}><Combobox url={REST_API_URL + "typeechanges/"} optionValueKey="idTypeEchange" optionLabelKey="libelle"
              onChange={this.handleTypeEchangeChange.bind(this)} placeholder="Type d'échange" default={this.getObjectProperty("idTypeEchange")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Contact ManyToOne */}
          <FormGroup controlId="idContact">
            <Col componentClass={ControlLabel} sm={2}>Contact</Col>
            <Col sm={6}>
              <AdvancedCombobox path="contacts" objectPath={REST_API_URL + "contrats/" + (this.getObjectProperty("idContrat") || this.props.match.params.idContrat) + "/contacts/"}
                objectClass={Contact} url={REST_API_URL + "contrats/" + (this.getObjectProperty("idContrat") || this.props.match.params.idContrat) + "/contacts/"}
                optionValueKey="idContact" optionLabelKey="fullName" default={this.getObjectProperty("idContact")} onChange={this.handleContactChange.bind(this)}
                afterAdd={this.afterContactAdd.bind(this)} isabled={this.getReadOnly()} enableSearch={true} withEdit={true} />
            </Col>
          </FormGroup>

          <FormGroup controlId="description">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Description</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}>
              <FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("description")} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>

          <FormGroup controlId="estRelance">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel></ControlLabel></Col>
            <Col sm={1}><Checkbox name="estRelance" onChange={this.handleCheckboxChange.bind(this)} checked={this.getObjectProperty("estRelance")} disabled={this.getReadOnly()}>Relance</Checkbox></Col>

            {this.getObjectProperty("estRelance") === true &&
              <Col sm={2}>
                <DatePicker dateFormat="DD/MM/YYYY" value={dateRelance} onChange={this.handleDateRelanceChange.bind(this)} disabled={this.getReadOnly()} />
              </Col>
            }

            {this.state.mode !== "add" && this.getObjectProperty("estRelance") === true && this.getObjectProperty("dateRelance") &&
              <Col sm={2}>
                <Button bsStyle="primary" onClick={this.createRelanceAlerte.bind(this)}>Générer une alerte</Button>
              </Col>
            }
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" &&
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>
          }
        </Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idEchange";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    const echangeObj = this.getEchange();

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(echangeObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Echange sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Echange créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/echanges/" + newObj.idEchange + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * getEchange
  * Returns Echange object
  **/
  getEchange() {
    let echangeObj = cloneObject(this.state.object);

    if(echangeObj.dateHeureEchange instanceof Date) {
      echangeObj.dateHeureEchange = getStringFromDate(echangeObj.dateHeureEchange);
    }

    if(echangeObj.estRelance === undefined) {
      echangeObj.estRelance = false;
    }

    if(echangeObj.estRelance === false) {
      echangeObj.dateRelance = null;
    }

    if(echangeObj.dateRelance instanceof Date) {
      echangeObj.dateRelance = getStringFromDate(echangeObj.dateRelance);
    }

    return echangeObj;
  }

  /**
  * handleDateHeureEchangeChange
  * Modify the state dateHeureEchange property from dateHeureEchange field change
  **/
  handleDateHeureEchangeChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateHeureEchange"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * handleDateRelanceChange
  * Modify the state dateRelance property from dateRelance field change
  **/
  handleDateRelanceChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateRelance"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * handleTypeEchangeChange
  * Modify the state idTypeEchange property from idTypeEchange Combobox change
  **/
  handleTypeEchangeChange(typeEchange) {
    let objState = this.state;
    objState.object["idTypeEchange"] = (typeEchange === undefined) ? null : typeEchange.idTypeEchange;
    this.setState(objState);
  }

  /**
  * handleContactChange
  * Modify the state idContact property from idContact Combobox change
  **/
  handleContactChange(contact) {
    let objState = this.state;
    objState.object["idContact"] = (contact === undefined) ? null : contact.idContact;
    this.setState(objState);
  }

  /**
  * afterContactAdd
  * Link contact to Contrat's Client
  **/
  afterContactAdd(contact) {
    rest({
      method: "PUT",
      path: REST_API_URL + "contrats/" + (this.getObjectProperty("idContrat") || this.props.match.params.idContrat) + "/contacts/",
      entity: JSON.stringify(contact),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Contact sauvegardé.'
          }
        });
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde du contact.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * createRelanceAlerte
  * Create relance Alerte
  **/
  createRelanceAlerte() {
    const path = REST_API_URL + this.getObjectPath() + "/alerte_relance";
    const echangeObj = this.getEchange();

    rest({
      method: "PUT",
      path: path,
      entity: JSON.stringify(echangeObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Alerte crééé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.pushHistory(APP_PATH + "/alertes/" + newObj.idAlerte + "/edit", state);
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

}
export default Echange;



// WEBPACK FOOTER //
// ./src/views/Entity/Echange.js